"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEventString = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const parseEventString = (value, className, style) => {
    let newValueString = value;
    if (newValueString.indexOf('\\n') !== -1) {
        newValueString = newValueString.replace(/\\n/g, ' ');
    }
    if (newValueString.indexOf('\\;') !== -1) {
        newValueString = newValueString.replace(/\\;/g, ';');
    }
    if (newValueString.indexOf('\\,') !== -1) {
        newValueString = newValueString.replace(/\\,/g, ',');
    }
    return ((0, jsx_runtime_1.jsx)("p", Object.assign({ className: className, style: style }, { children: newValueString })));
};
exports.parseEventString = parseEventString;
